import { inject, observer } from 'mobx-react';
import * as moment from 'moment';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { UserStore } from '../../_stores/UserStore';
import { NoProfileImageUrl } from '../../images/images';

interface IProps {
    store: ApplicationStore;
}

export enum FactId {
    NICKNAME = '1',
    BIRTH_DATE = '2',
    BIRTH_PLACE = '3',
    CURRENT_PLACE = '4'
}

@inject('store')
@observer
export class FamilyMemberPage extends React.Component<RouteComponentProps<any> & IProps> {
    private static renderTextWithHeader(header: string, value: String) {
        if (value && value.trim() === '') {
            return null;
        }
        return (
            <div style={styles.headerContainer}>
                <p style={styles.headerText}>{header}</p>
                <p style={styles.valueText}>{value}</p>
            </div>
        );
    }

    public render() {
        if (!this.props.store.userFamilyStore || !this.props.store.userFamilyStore.familiesAreLoaded) {
            return null;
        }

        // const userStore = this.props.store.userStore;
        const userFamilyStore = this.props.store.userFamilyStore;
        const family = userFamilyStore.getFamilyByID(parseInt(this.props.match.params.id));
        const user = userFamilyStore.getFamilyMemberByID(parseInt(this.props.match.params.memberID));
        if (!user) {
            throw new Error('Failed to load user: ' + parseInt(this.props.match.params.memberID));
        }
        const joinedDate = family.members.find(u => u.id === user.id)!.joinedFamilyTimestamp;
        const nicknameFact = userFamilyStore.getUserFact(user.id, FactId.NICKNAME);

        return (
            <FullScreenModalContainer
                {...this.props}
                justifyContent="space-between"
                alignItems="center"
                onPressExit={() => this.props.history.push(`/familydetail/${parseInt(this.props.match.params.id)}`)}
            >
                <FullContainer style={styles.flex}>
                    <p style={styles.nameContainer}>{UserStore.getPublicUserFullName(user) + ' - ' + family.name}</p>
                    <div style={styles.outterInputContainer}>
                        <div style={styles.leftInputSide}>
                            {joinedDate && FamilyMemberPage.renderTextWithHeader('Joined Family', moment(joinedDate).format('MM / DD / YYYY'))}
                            {nicknameFact && FamilyMemberPage.renderTextWithHeader('Nickname', nicknameFact.value)}
                            {FamilyMemberPage.renderTextWithHeader('Email', user.email)}
                        </div>
                        <div style={styles.rightInputSide}>
                            <img style={styles.profileImage} src={user.profile_image_url || NoProfileImageUrl} />
                        </div>
                    </div>
                </FullContainer>
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    flex: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    } as React.CSSProperties,
    headerContainer: { height: 100 },
    headerText: {
        fontSize: 14,
        fontWeight: 900,
        opacity: 0.5,
        marginBottom: 5
    } as React.CSSProperties,
    valueText: {
        fontSize: 20,
        color: '#423F4E'
    },
    nameContainer: {
        height: 50,
        marginTop: 50,
        marginBottom: 20,
        fontSize: 27,
        color: 'black',
        fontWeight: 900,
        width: '100%',
        textAlign: 'center'
    } as React.CSSProperties,
    outterInputContainer: {
        width: '100%',
        display: 'flex',
        height: '80%'
    },
    leftInputSide: {
        width: '50%',
        height: '100%',
        dispaly: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'space-between',
        paddingLeft: 180
    } as React.CSSProperties,
    rightInputSide: {
        width: '50%'
    },
    profileImage: {
        width: '80%',
        objectFit: 'contain',
        maxHeight: '80%'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/Pages/FamiliesPage/FamilyMemberPage.tsx